import { useState } from "react";
import { UserPlus, X } from "lucide-react";
import { Drawer, DrawerContent, DrawerTitle, DrawerDescription } from "@/components/ui/drawer";
import { PositionPicker } from "@/components/PositionPicker";
import { PlayerChip } from "@/components/PlayerChip";
import { useAuth } from "@/context/AuthContext";

const EMPTY = { first_name: "", last_name: "", primary_position: "" };

export const Guests = ({ data, act }) => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(EMPTY);
  const m = data.match;
  const mine = data.players.filter((p) => p.is_guest && (p.added_by === user.id || user.role === "admin"));
  const others = data.players.filter((p) => p.is_guest && !mine.includes(p));
  const myCount = data.players.filter((p) => p.is_guest && p.added_by === user.id).length;
  const registered = data.players.some((p) => p.id === user.id && !p.is_guest && ["confirmed", "waiting_list"].includes(p.registration_status));
  const canRemove = m.status === "scheduled" && (user.role === "admin" || (!data.draft?.started && (registered || myCount > 0)));
  const removeBtn = (g) => canRemove && (
    <span role="button" data-testid={`remove-guest-${g.id}`} onClick={() => window.confirm(`Retirer ${g.short_name} ?`) && act("delete", `/guests/${g.id}`, undefined, "Invité retiré")} className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center"><X className="w-4 h-4 text-red-500" /></span>
  );
  const canAdd = m.status === "scheduled" && (data.registration_open || user.role === "admin") && myCount < 10;

  const submit = async () => {
    const r = await act("post", "/guests", f, `${f.first_name} a été ajouté comme invité`);
    if (r) { setF(EMPTY); setOpen(false); }
  };

  return (
    <div className="space-y-2" data-testid="guests-section">
      {canAdd && (
        <button data-testid="add-guest-button" onClick={() => setOpen(true)} className="w-full flex items-center justify-center gap-2 rounded-2xl border-2 border-dashed border-orange-300 bg-orange-50 text-orange-600 py-3 text-sm font-bold active:scale-[0.98] transition">
          <UserPlus className="w-4 h-4" /> Ajouter un invité {myCount > 0 && <span className="num text-xs">({myCount}/10)</span>}
        </button>
      )}
      {mine.length > 0 && <p className="text-xs font-bold text-orange-600 uppercase tracking-wider pt-1">Mes invités</p>}
      {mine.map((g) => (
        <PlayerChip key={g.id} p={g} testid={`guest-${g.id}`} right={removeBtn(g)} />
      ))}
      {canRemove && others.length > 0 && <p className="text-xs font-bold text-slate-500 uppercase tracking-wider pt-1" data-testid="other-guests-title">Autres invités</p>}
      {canRemove && others.map((g) => <PlayerChip key={g.id} p={g} testid={`guest-${g.id}`} right={removeBtn(g)} />)}
      <Drawer open={open} onOpenChange={setOpen}>
        <DrawerContent className="bg-white max-w-md mx-auto">
          <div className="px-5 pb-6 overflow-y-auto max-h-[85dvh] space-y-3" data-testid="guest-sheet">
            <DrawerTitle className="font-display text-xl">Ajouter un invité</DrawerTitle>
            <DrawerDescription className="text-xs text-slate-500">Pour un ami qui n'a pas l'application. Il prend une place comme un joueur normal (priorité la plus basse si le match est complet).</DrawerDescription>
            <div className="grid grid-cols-2 gap-2">
              <input data-testid="guest-first-name" className="gg-input" placeholder="Prénom" value={f.first_name} onChange={(e) => setF({ ...f, first_name: e.target.value })} />
              <input data-testid="guest-last-name" className="gg-input" placeholder="Nom" value={f.last_name} onChange={(e) => setF({ ...f, last_name: e.target.value })} />
            </div>
            <p className="text-xs font-bold text-slate-500 uppercase">Poste</p>
            <PositionPicker value={f.primary_position} onChange={(v) => setF({ ...f, primary_position: v })} testid="guest-position" />
            <button data-testid="guest-submit" disabled={!f.first_name.trim() || !f.last_name.trim() || !f.primary_position} onClick={submit}
              className="w-full rounded-2xl bg-orange-500 text-white font-display font-black py-4 active:scale-[0.98] transition disabled:opacity-40">AJOUTER L'INVITÉ</button>
          </div>
        </DrawerContent>
      </Drawer>
    </div>
  );
};
